import React from 'react';
import { Box, Typography, Grid, Card, CardActionArea, CardContent, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import ChecklistIcon from '@mui/icons-material/Checklist';
import KeyIcon from '@mui/icons-material/Key';

// Personal productivity hub. Tools are added here as they ship.
const ITEMS = [
  { icon: PersonOutlineIcon, title: 'Profile', desc: 'Your account details', path: 'profile' },
  { icon: ChecklistIcon, title: 'Tasks', desc: 'Personal to-do list', path: 'tasks' },
  { icon: KeyIcon, title: 'Password Generator', desc: 'Strong passwords + strength meter', path: 'password-generator' },
];

export default function WorkspacePage() {
  const navigate = useNavigate();
  return (
    <Box sx={{ p: 3, maxWidth: 1100, mx: 'auto' }}>
      <Typography variant="h4" sx={{ fontWeight: 700, mb: 0.5 }}>Workspace</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Your personal productivity hub.
      </Typography>
      <Grid container spacing={2}>
        {ITEMS.map(({ icon: Icon, title, desc, path }) => (
          <Grid item xs={12} sm={6} md={4} key={path}>
            <Card variant="outlined" sx={{ borderRadius: 2, height: '100%', transition: 'transform 0.15s ease, box-shadow 0.15s ease', '&:hover': { transform: 'translateY(-3px)', boxShadow: 4 } }}>
              <CardActionArea onClick={() => navigate(`/dashboard/${path}`)} sx={{ height: '100%' }}>
                <CardContent>
                  <Stack direction="row" spacing={1.5} alignItems="center">
                    <Box sx={{ width: 44, height: 44, borderRadius: 2, display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: 'primary.main', color: 'primary.contrastText', flexShrink: 0 }}>
                      <Icon />
                    </Box>
                    <Box sx={{ minWidth: 0 }}>
                      <Typography variant="subtitle1" sx={{ fontWeight: 700, lineHeight: 1.2 }}>{title}</Typography>
                      <Typography variant="body2" color="text.secondary">{desc}</Typography>
                    </Box>
                  </Stack>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
